import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as WarningSVG } from "go-core/images/svg/warning-alert.svg";

export const InvoiceKSeFAlert = () => {
	const { t } = useTranslation();

	return (
		<Alert variant="warning" className="d-flex align-items-center column-gap-3">
			<WarningSVG className="flex-shrink-0" />
			<p className="mb-0">{t("modules.invoice.action.error_on_adding_invoice_to_ksef_occurred.title")}</p>
		</Alert>
	);
};
